module.exports = __webpack_public_path__ + "img/sig.e121dc28.svg";